// extracted by mini-css-extract-plugin
module.exports = {"btn":"styles_btn__3k3v9","small":"styles_small__2PFg3","big":"styles_big__2xb9P"};